import { trigger, state, style, transition, group, animate } from '@angular/animations';

export const QuestionnaireAnimations = [
	trigger('isSelected', [
		state(
			'selected',
			style({
				opacity: 1,
			})
		),
		state(
			'unselected',
			style({
				filter: 'grayscale(1.0)',
			})
		),
		transition('selected => unselected', group([animate('1s')])),
		transition('unselected => selected', group([animate('1s')])),
	]),
	trigger('backgroundSelected', [
		state(
			'A',
			style({
				background: 'linear-gradient(180deg, rgba(255,255,255,1) 60%, #69E1FE 100%)',
			})
		),
		state(
			'B',
			style({
				background: 'linear-gradient(180deg, rgba(255,255,255,1) 60%, #68FCEB 100%)',
			})
		),
		state(
			'C',
			style({
				background: 'linear-gradient(180deg, rgba(255,255,255,1) 60%, #7DFE77 100%)',
			})
		),
	]),
	trigger('titleBackgroundSelected', [
		state(
			'A',
			style({
				background: '#69E1FE',
			})
		),
		state(
			'B',
			style({
				background: '#68FCEB',
			})
		),
		state(
			'C',
			style({
				background: '#7DFE77',
			})
		),
	]),
];
